import React from 'react';
import T from 'i18n';
import TableWrapper from './TableWrapper';

const SearchPage = () => {
  return <TableWrapper category={T.translate('case.searchMode')} />;
};

export default SearchPage;
